import { render, staticRenderFns } from "./register-portal-ktba.vue?vue&type=template&id=24ed07d3&scoped=true"
import script from "./register-portal-ktba.vue?vue&type=script&lang=ts"
export * from "./register-portal-ktba.vue?vue&type=script&lang=ts"
import style0 from "./register-portal-ktba.vue?vue&type=style&index=0&id=24ed07d3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ed07d3",
  null
  
)

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VApp,VMain,VOverlay,VProgressCircular,VSnackbar})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24ed07d3')) {
      api.createRecord('24ed07d3', component.options)
    } else {
      api.reload('24ed07d3', component.options)
    }
    module.hot.accept("./register-portal-ktba.vue?vue&type=template&id=24ed07d3&scoped=true", function () {
      api.rerender('24ed07d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "layouts/register-portal-ktba.vue"
export default component.exports